import gsap from 'gsap';
import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
gsap.registerPlugin(DrawSVGPlugin);

export function initCircle(element) {
    circleAnimation();
}

function circleAnimation() {

    gsap.fromTo('#circle-wrap circle', {drawSVG: '0%'}, {duration: 1, drawSVG: '100%', ease: 'none'})
}
